import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'

import content from 'prismic-translates/page-vip.json'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content])

type Props = {
  nextLevelName: string
  currentLevelName: string
}
function Statuses(props: Props) {
  return (
    <div className={classes.root}>
      <h6 className={`mt-typography-h6 ${classes.col}`}>
        {t('your_status')}
        <span className={classes.status}>{props.currentLevelName || t('wait')}</span>
      </h6>
      <h6 className={`mt-typography-h6 ${classes.col}`}>
        {t('next_status')}
        <span className={classes.status}>{props.nextLevelName}</span>
      </h6>
    </div>
  )
}

export default Statuses
